import { IConditionalNode } from '../../../../helpers/conditional-nodes.helpers';
import { required } from '../../../../helpers/function.helpers';
import { EnergyProductId } from '../../energy/energy.model';
import {
  HeaterProducts,
  HeatSourceOptions,
  HeatingType,
  HeatingPropertyName,
  energyProductsIdToNameMap,
} from '../heating.model';

/**
 * Tree to select heat producer product depending on heating type
 */
export const conditionalHeaterProductId: IConditionalNode<HeaterProducts> = {
  property: HeatingPropertyName.Type,
  map: {
    // Heating product for heat pumps depending on heat source
    [HeatingType.HeatPump]: [
      {
        property: HeatingPropertyName.HeatSource,
        map: {
          [HeatSourceOptions.Air]: HeaterProducts.HeatPumpAirToWater,
          [HeatSourceOptions.Water]: HeaterProducts.HeatPumpWater,
          [HeatSourceOptions.ExhaustAir]: HeaterProducts.HeatPumpAirToWater,
          [HeatSourceOptions.Geothermal]: HeaterProducts.HeatPumpGeothermal,
        },
      },
    ],

    // Heating product for boiles depending on fuel type
    [HeatingType.Boiler]: {
      property: HeatingPropertyName.FuelType,
      map: {
        [required(energyProductsIdToNameMap[EnergyProductId.FuelOil1])]:
          HeaterProducts.FuelBoiler,
        [required(energyProductsIdToNameMap[EnergyProductId.FuelOil2])]:
          HeaterProducts.FuelBoiler,
        [required(energyProductsIdToNameMap[EnergyProductId.WoodPellets])]:
          HeaterProducts.PelletsBoiler,
        [required(energyProductsIdToNameMap[EnergyProductId.Biogas])]:
          HeaterProducts.BiogasBoiler,
      },
    },
    [HeatingType.DistrictHeating]: HeaterProducts.DistrictHeating,
    [HeatingType.DirectElectricHeating]: HeaterProducts.DirectElectricHeating,
  },
};
